"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_native_1 = require("react-native");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var DoubleTapView_1 = require("./DoubleTapView");
var SCREEN_WIDTH = react_native_1.Dimensions.get('window').width;
var ANIMATED_HEART_SIZE = 80;
var heartIconFilled = require('../assets/ic_filled_heart.png');
exports.LikeOnDoubleTap = function (_a) {
    var children = _a.children, onDoubleTap = _a.onDoubleTap, viewHeight = _a.viewHeight, viewWidth = _a.viewWidth;
    var likeAnimSize = react_1.useState(new react_native_1.Animated.Value(0))[0];
    var likeAnimOpacity = react_1.useState(new react_native_1.Animated.Value(0))[0];
    var theme = ThemeProvider_1.useTheme();
    var likeAnimation = function () {
        onDoubleTap && onDoubleTap();
        react_native_1.Animated.timing(likeAnimSize, { toValue: 1, duration: 300 }).start();
        react_native_1.Animated.timing(likeAnimOpacity, { toValue: 1, duration: 600 }).start(function () {
            return setTimeout(function () {
                react_native_1.Animated.timing(likeAnimSize, { toValue: 0, duration: 200 }).start(function () {
                    return react_native_1.Animated.timing(likeAnimOpacity, { toValue: 0, duration: 1 }).start();
                });
            }, 500);
        });
    };
    var likeAnimationView = function () { return (react_1.default.createElement(react_native_1.Animated.Image, { source: heartIconFilled, style: {
            zIndex: 2,
            height: ANIMATED_HEART_SIZE,
            width: ANIMATED_HEART_SIZE,
            alignSelf: 'center',
            resizeMode: 'contain',
            position: 'absolute',
            top: (SCREEN_WIDTH - ANIMATED_HEART_SIZE) / 2,
            tintColor: theme.ColorBrand2Low,
            opacity: likeAnimOpacity.interpolate({ inputRange: [0, 1], outputRange: [0, 1] }),
            transform: [
                { scaleX: likeAnimSize.interpolate({ inputRange: [0, 1], outputRange: [0.01, 1] }) },
                { scaleY: likeAnimSize.interpolate({ inputRange: [0, 1], outputRange: [0.01, 1] }) }
            ]
        } })); };
    return (react_1.default.createElement(DoubleTapView_1.DoubleTapView, { onDoubleTap: likeAnimation },
        react_1.default.createElement(react_native_1.View, { style: { height: viewHeight, width: viewWidth } },
            likeAnimationView(),
            children)));
};
